import * as React from 'react';

import { PhotoModel } from '@App/common/models'

import './photo.css'

export interface IPhotoProps {
  thisPhoto: PhotoModel;
  openLightBox: (i: number) => any;
  index: number;
}

export default class IPhoto extends React.PureComponent<IPhotoProps, any> {
  
  public handleEvent = (param: any) => (event: any) => {
    // const name = param;
    // tslint:disable-next-line:no-debugger
    // debugger;
    // alert('has loaded');
    // alert(name);
  }
  
  public handleOnClick = () => (event: any) => {
    this.props.openLightBox(this.props.index);
  }

  public getThumbSrc(src: string): string{
    const i: number = src.lastIndexOf('/') + 1;
    return src.slice(0, i) + 'THUMB_' + src.slice(i)
  }

  public render() {
    return (
      <div className='thumb_size'>
        <img
        className='object_fit'
          src={this.getThumbSrc(this.props.thisPhoto.displaySrc)}
          onLoad={this.handleEvent('coach')}
          onClick={ this.handleOnClick() }
          // onError={this.handleImageErrored.bind(this)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/bundles/photogrid/components/photo.tsx